<template>
    <div class="main-filters">
        <div class="main-filters__search">
            <el-input
                v-model="searchText"
                style="width: 100%"
                :placeholder="translate('search_label')"
                @input='pesquisar'
            >
                <template #prefix>
                    <i class="el-icon-search"></i>
                </template>
            </el-input>
            <el-popover
                v-model="showModalAdvancedFilters"
                trigger="manual"
                width="570"
                offset="0"
            >
                <template #reference>
                    <el-button
                        slot="reference"
                        type="text"
                        icon="el-icon-s-operation"
                        class="main-filters__btn_advanced_filters"
                        @click="
                            showModalAdvancedFilters = !showModalAdvancedFilters
                        "
                    >
                        {{ translate('btn_advanced_filters') }}
                    </el-button>
                </template>
                <template #default>
                    <dialog-advanced-filters
                        @handleFilter="handleFilter"
                        @applyFilter="applyFilter"
                        @clear="clearFilters"
                        :show="showModalAdvancedFilters"
                    />
                </template>
            </el-popover>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    components: {
        dialogAdvancedFilters: () =>
            import(
                '@/modules/warehouse/views/pages/viewBatchRecord/components/filters/dialog-advanced-filters.vue'
            )
    },
    data() {
        return {
            protocols: [],
            showModalAdvancedFilters: false,
            searchText: '',
            filter: {}
        };
    },
    computed: {
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.messages.view_invoices_filter';
            return this.$tc(`${base}.${key}`, params);
        },
        handleFilter(filters, initialLoad) {
            this.filter = filters;
            if (initialLoad) {
                this.applyFilter();
            }
        },
        applyFilter() {
            this.$emit('changeFilters', {searchText: this.searchText, ...this.filter});
            this.showModalAdvancedFilters = false;
        },
        clearFilters() {
            this.searchText = '';
            this.showModalAdvancedFilters = false;
            this.pesquisar();
        },
        pesquisar() {
            if (this.searchText.length >= 1 && this.searchText.length < 3) {
                return;
            }
            this.$emit('changeFilters', {searchText: this.searchText, ...this.filter});
        }
    },
    beforeDestroy() {
        this.clearFilters();
    }
};
</script>

<style scoped lang="scss">
.main-filters {
    .main-filters__search {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 16px;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .el-input {
            i.el-icon-search {
                color: #183b57;
                font-size: 20px;
                margin: 10px 2px;
            }
        }

        .main-filters__btn_advanced_filters {
            border: 1px solid #183b57;
            font-size: 14px;
            padding: 9px 16px;
            height: 40px;
        }
    }

    .main-filters__selected {
        > h3 {
            margin: 16px 0;
            color: #3b3b3b;
            font-weight: 500;
            font-size: 16px;
            padding-right: 10px;
        }

        > span {
            font-style: italic;
        }

        display: flex;
        align-items: center;

        .main-filters__selected__options {
            display: flex;
            align-items: center;

            .el-icon {
                box-sizing: border-box;
            }

            .el-icon:hover {
                background-color: rgba(255, 255, 255, 0.4);
                border-radius: 100%;
            }

            .main-filters__selected__options_content {
                display: flex;

                .main-filters__selected__options_status {
                    display: inline-flex;
                    padding-right: 5px;
                    text-transform: capitalize;
                }
            }

            .el-button {
                background-color: #359138;
                color: white;
                font-size: 12px;
                text-transform: lowercase;
                display: flex;
            }

            .main-filters__selected__options_status_clear {
                background-color: #ebf4eb;
                color: #359138;
                font-weight: 300;
                font-size: 12px;
                align-items: center;
            }
        }
    }
}
</style>
